import { render, staticRenderFns } from "./ShowcaseSection.vue?vue&type=template&id=19323469&scoped=true"
import script from "./ShowcaseSection.vue?vue&type=script&lang=js"
export * from "./ShowcaseSection.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseSection.vue?vue&type=style&index=0&id=19323469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19323469",
  null
  
)

export default component.exports